module.exports = __webpack_public_path__ + "static/media/ebuilt-banner-tablet.5c68aab0.jpg";